import * as Yup from "yup";
import { TranslateFunction } from "../../../contexts/LocalizationContext";

export const accountAgreementValidationSchema = (translate : TranslateFunction) => Yup.object().shape({
  isAgreementAccepted: Yup.boolean()
    .oneOf([true], translate("settings.acceptAgreement"))
    .required(translate("settings.acceptAgreement"))
});
